import type { ScriptedBeat } from '../content/beats';
import type { EventBus } from './EventBus';

export interface BeatsSystemOptions {
  bus: EventBus;
  beats: readonly ScriptedBeat[];
}

export class BeatsSystem {
  private readonly dispatched = new Set<string>();

  constructor(private readonly opts: BeatsSystemOptions) {}

  tick(fictionalMinutes: number): void {
    for (const beat of this.opts.beats) {
      if (this.dispatched.has(beat.id)) continue;
      if (fictionalMinutes < beat.fictionalMinutes) continue;
      this.dispatched.add(beat.id);
      this.opts.bus.emit('beat:triggered', { beatId: beat.id, term: beat.term });
      // Note: teach panel is no longer auto-fired. Modals open directly and
      // expose a "What is X? ↗" link so the educational content is opt-in.
    }
  }
}
